import Swal from "sweetalert2";

const swalPlugins =  {
    install: (app) => {
        app.config.globalProperties.$swal = Swal;
    }
}
export default swalPlugins;
